import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { NumberUtilities, assert, release } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: DropShadowFilter
var DropShadowFilter = /** @class */ (function (_super) {
    __extends(DropShadowFilter, _super);
    function DropShadowFilter(distance, angle, color, alpha, blurX, blurY, strength, quality, inner, knockout, hideObject) {
        if (distance === void 0) { distance = 4; }
        if (angle === void 0) { angle = 45; }
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 1; }
        if (blurX === void 0) { blurX = 4; }
        if (blurY === void 0) { blurY = 4; }
        if (strength === void 0) { strength = 1; }
        if (quality === void 0) { quality = 1; }
        if (inner === void 0) { inner = false; }
        if (knockout === void 0) { knockout = false; }
        if (hideObject === void 0) { hideObject = false; }
        var _this = _super.call(this) || this;
        _this.filterName = 'dropShadow';
        _this.distance = distance;
        _this.angle = angle;
        _this.color = color;
        _this.alpha = alpha;
        _this.blurX = blurX;
        _this.blurY = blurY;
        _this.strength = strength;
        _this.quality = quality;
        _this.inner = inner;
        _this.knockout = knockout;
        _this.hideObject = hideObject;
        return _this;
    }
    DropShadowFilter.FromUntyped = function (obj, sec) {
        // obj.colors is an array of RGBA colors.
        // Here it contains exactly one color object, which maps to color and alpha.
        release || assert(obj.colors && obj.colors.length === 1, 'colors must be Array of length 1');
        var color = obj.colors[0] >>> 8;
        var alpha = (obj.colors[0] & 0xff) / 0xff;
        // obj.angle is represented in radians, the api needs degrees
        var angle = obj.angle * 180 / Math.PI;
        // obj.compositeSource maps to !hideObject
        var hideObject = !obj.compositeSource;
        return new sec.flash.filters.DropShadowFilter(obj.distance, angle, color, alpha, obj.blurX, obj.blurY, obj.strength, obj.quality, obj.inner, obj.knockout, hideObject);
    };
    Object.defineProperty(DropShadowFilter.prototype, "distance", {
        get: function () {
            return this._distance;
        },
        set: function (value) {
            this._distance = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (value) {
            this._angle = +value % 360;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value /*uint*/) {
            this._color = (value >>> 0) & 0xffffff;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = NumberUtilities.clamp(+value, 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "blurX", {
        get: function () {
            return this._blurX;
        },
        set: function (value) {
            this._blurX = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "blurY", {
        get: function () {
            return this._blurY;
        },
        set: function (value) {
            this._blurY = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "hideObject", {
        get: function () {
            return this._hideObject;
        },
        set: function (value) {
            this._hideObject = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "inner", {
        get: function () {
            return this._inner;
        },
        set: function (value) {
            this._inner = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "knockout", {
        get: function () {
            return this._knockout;
        },
        set: function (value) {
            this._knockout = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (value /*int*/) {
            this._quality = NumberUtilities.clamp(value | 0, 0, 15);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropShadowFilter.prototype, "strength", {
        get: function () {
            return this._strength;
        },
        set: function (value) {
            this._strength = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    DropShadowFilter.prototype.toAwayObject = function () {
        return this;
    };
    DropShadowFilter.prototype.clone = function () {
        return new this.sec.flash.filters.DropShadowFilter(this._distance, this._angle, this._color, this._alpha, this._blurX, this._blurY, this._strength, this._quality, this._inner, this._knockout, this._hideObject);
    };
    // Called whenever the class is initialized.
    DropShadowFilter.classInitializer = null;
    // List of static symbols to link.
    DropShadowFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    DropShadowFilter.instanceSymbols = null;
    return DropShadowFilter;
}(BitmapFilter));
export { DropShadowFilter };
